import { createContext } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { Credentials } from 'pages/Auth/types';

export const defaultData: Credentials = {
  email: '',
  password: '',
};

export enum LoginState {
  password = 'password',
  passwordless = 'passwordless',
  passwordlessSuccess = 'passwordlessSuccess',
}

export type LoginStateContextType = {
  loginState: LoginState;
  loginFormMethods: UseFormReturn<Credentials>;
  switchToPasswordlessLogin: () => void;
  switchToPasswordlessSuccess: () => void;
  switchToPasswordLogin: () => void;
};

export const LoginStateContext = createContext<LoginStateContextType | undefined>(undefined);
